import Tooltip from "@/tooltip";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import * as SolidIcons from "@/icons/solid";

const CustomOption = (props) => {
	let { children, className, cx, getStyles, isDisabled, isFocused, isSelected, innerRef, innerProps, data } = props;

	const styles = getStyles("option", props);

	const color = useMemo(() => {
		if (isSelected) {
			return "white";
		} else if (isFocused) {
			return "rgb(35, 42, 50)";
		} else if (isDisabled) {
			return "gray";
		} else {
			return "rgb(35, 42, 50)";
		}
	}, [isSelected, isFocused, isDisabled]);

	const Icon = data.icon ? SolidIcons[data.icon] : null;

	return (
		<div
			style={{
				...styles,
				color,
				// backgroundColor: isSelected ? "#EA611C" : isFocused ? "rgba(234, 97, 28, 0.04)" : "white",
			}}
			className={cx(
				{
					option: true,
				},
				className,
			)}
			ref={innerRef}
			{...innerProps}
		>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div className="flex items-center">
					{Icon ? <Icon className="h-8 w-8 mr-3" /> : null}
					<div>
						{children}
						{data.description ? (
							<>
								<div
									style={{
										fontSize: "1.125rem",
										color: isSelected
											? "white"
											: isSelected
											? "white"
											: isDisabled
											? styles.color
											: "gray",
									}}
								>
									{data.description}
								</div>
							</>
						) : null}
					</div>
				</div>

				{data.statusMessage ? (
					<>
						<Tooltip content={data.statusMessage}>
							<InformationCircleIcon style={{ height: "2rem", display: "block" }} />
						</Tooltip>
					</>
				) : null}
			</div>
		</div>
	);
};

export { CustomOption };
